/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_SavedInputs */

const vi_shop_group_saved = /** @type {(inputs: Shop_Group_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu nhóm sản phẩm.`)
};

/**

* @param {Shop_Group_SavedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_saved = /** @type {((inputs?: Shop_Group_SavedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_SavedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_saved(inputs)
});